import { adminAuthApiClient } from "../adminAuthApiClient";
import { AdminAuthService } from "./adminAuthService";


// ADps 5.1

class AdminPanelSerive{

  async getCurrentUser() {
  try {
    const response = await adminAuthApiClient.get('/api/auth/admin/me');
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      throw new Error("Session expired");
    }
    throw error;
  }
}
async getstudentsRecords() {
  try {
    const response = await adminAuthApiClient.get('/api/students');
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      throw new Error("Session expired");
    }
    throw error;
  }
}
async logout() {
  try {
    const response = await adminAuthApiClient.post('/api/auth/admin/logout');
    return response.data;
  } finally {
    // nothing to clear client-side
  }
}
    
    // async getCurrentUser(){
    //     const token = AdminAuthService.getToken()
    //     // before get the entry to admin verify the token
    //     if(!token){
    //         throw new Error("Not authenticate token found")
    //     }
    //     try {
    //         const response = await apiClient.get('/api/auth/admin/me',{
    //         headers:{
    //             "Authorization" : `Bearer ${token}`
    //         } 
    //     })
    //     console.log("response.data =>",response.data);
    //     return response.data
    //     } catch (error) {
    //         if(error.response?.status === 401){
    //            throw new Error("Load to failed data", error.message)
    //         }
    //         AdminAuthService.clearadminAuthData()
    //     }

    // }
    // async getstudentsRecords(){
    //     const token = AdminAuthService.getToken();
    //     try {
    //         const response = await apiClient.get('/api/students',{
    //         headers:{
    //             "Authorization" : `Bearer ${token}`
    //         } 
    //     })
    //      return response.data
    //     } catch (error) {
    //         if (error.response?.status === 401) {
    //             throw new Error("Session expired, please login again", error.message)
    //         }else{
    //             throw new Error("Failed to load data", error.message)
    //         }
    //     }
    // }
    // async logout (){
    //     // const useSnackbar = enqueueSnackbar()
    //     const token = AdminAuthService.getToken();
    //     // console.log("logout token:", token);
    //     if(!token){
    //         return
    //     }
    //     try {
    //         const response = await apiClient.post('/api/auth/admin/logout',{},{
    //         headers:{
    //             "Authorization" : `Bearer ${token}`
    //         } 
    //     })
    //     console.log("response.data=>",response.data);
        
    //         return response.data
    //     } catch (error) {
    //         throw new Error("Logged out Failed", error.message)           
            
    //     }finally{
    //         AdminAuthService.clearadminAuthData()
    //     }
    // }



    
}
export const adminpanelservice = new AdminPanelSerive()